/**
 * queryClient.js — A única instância de QueryClient da aplicação.
 *
 * Contrato definido em docs/adr/ADR-007-ESTADO-DE-SERVIDOR-REACT-QUERY.md.
 * Não crie outro QueryClient em lugar nenhum: duas instâncias = dois caches,
 * e o `clear()` do logout só limparia um deles.
 *
 * @module queryClient
 */
import { QueryClient } from '@tanstack/react-query';

/** Códigos em que repetir a requisição não ajuda — e atrapalha. */
const SEM_RETRY = [400, 401, 403, 404, 422];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,            // 30s: ir e voltar numa tela não refaz a requisição
      gcTime: 5 * 60_000,           // 5min fora de tela e o cache morre
      refetchOnWindowFocus: false,  // o sistema fica aberto o dia todo; refocar não é evento
      retry: (tentativas, erro) => {
        // 401/403 já são tratados pelo apiFetch (refresh + queda de sessão).
        if (SEM_RETRY.includes(erro?.status)) return false;
        return tentativas < 1;      // uma segunda chance, só
      },
    },
    // Escrita NUNCA se repete sozinha: repetir um POST duplica contrato/fatura/processo.
    mutations: { retry: 0 },
  },
});

/**
 * Apaga todo o cache de servidor. Chamado no logout e em qualquer morte de
 * sessão: cache que sobrevive ao logout é dado de um escritório aparecendo na
 * sessão de outro — a mesma família da falha do S2.
 */
export function limparCacheDeSessao() {
  queryClient.clear();
}
